import { Box, Container, Grid } from '@chakra-ui/react';

import Info from '@components/events/Info';
import Tabs from '@components/events/Tabs';
import Ticket from '@components/events/Ticket';
import { EventType } from '@lib/types';

import { ContainerMaxW } from '../../layouts/EventLayout';

type Props = {
  event: EventType;
};

const TabsSection = ({ event }: Props) => {
  return (
    <Box
      w="full"
      boxShadow="0px 1px 1px rgba(0, 0, 0, 0.1)"
      position={{ md: 'sticky' }}
      top={{ md: 0 }}
      bg="#fff"
      zIndex="2"
    >
      <Container maxW={ContainerMaxW}>
        <Tabs event={event} />
      </Container>
    </Box>
  );
};

const InfoSection = ({ event }: Props) => {
  return (
    <Box w="full" bg="#fff">
      <Container
        maxW={ContainerMaxW}
        display={{ base: 'inherit', md: 'none' }}
        pb={'45px'}
        bg="#f7f7f7"
      >
        <Ticket event={event} />
      </Container>

      <TabsSection event={event} />

      <Container maxW={ContainerMaxW} py={'60px'}>
        <Grid
          templateColumns={{
            base: 'minmax(0, 1fr)',
            md: 'minmax(0, 1fr) 410px',
          }}
          columnGap={'60px'}
        >
          <Box>
            <Info event={event} />
          </Box>
          <Box display={{ base: 'none', md: 'block' }}>
            <Ticket
              event={event}
              position={{ md: 'sticky' }}
              // 124px is from Tabs height and InfoSection padding top
              top={{ md: '124px' }}
            />
          </Box>
        </Grid>
      </Container>
    </Box>
  );
};

export default InfoSection;
